module.exports = __webpack_public_path__ + "static/media/logo-18.b6db897a.jpg";